
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import api from '../../api';

export default {

beforeRouteEnter: (to, from, next) => {
next((vm) => {
if (vm.refresh(to, from)) {
vm.updates = JSON.parse(localStorage.getItem('updates'));
} else {
localStorage.getItem('updates') && localStorage.removeItem('updates')
}
});
},
components: {
Checker,
CheckerItem,
Group,
Cell,
Badge,
XButton,
},
mounted() {
this.getCompanyCapacityInfo();
},
activated() {
},
data() {
return {
transportType: '',
mainBusiness: '',
service: '',
companyType: '',
goodsType: '',

updates: {
transportType: [],
mainBusiness: [],
service: [],
companyType: [],
goodsType: [],
},
};
},
computed: {
allDic() {
return this.$store.state.allDic;
},
companyStatus() {
return this.$store.state.companyStatus;
},
},
watch : {
'updates' : {
handler:function(val) {
console.log(JSON.stringify(val))

localStorage.setItem('updates', JSON.stringify(val))
},
deep: true, // 深度监听
},
},
methods: {
refresh (to, form) {
const array = ['authTruckInfo', 'authLineInfo', 'authInCityInfo']
if (array.includes(form.name)) {
return true;
} else {
return false;
}
},
getCompanyCapacityInfo() {
api.vega.company.getCompanyCapacityInfo({
pageCode: 'auth/transport',
}).then((res) => {
const data = res.data.data;
this.updates = { ...this.updates, ...data };
});
},
save() {
const { transportType, mainBusiness, service, companyType, goodsType } = this.updates;
if (this.updates.trucksCount === 0) {
this.$vux.toast.text('请至少维护一条车辆信息');
return;
}
if (this.updates.incityCount === 0 && this.updates.linesCount === 0) {
this.$vux.toast.text('请至少维护一条线路或同城信息');
return;
}
if (!transportType.length || !mainBusiness.length || !service.length || !companyType.length || !goodsType.length) {
this.$vux.toast.text('请完善信息');
} else {
const obj = {
transportType,
mainBusiness,
service,
companyType,
goodsType,
}
api.vega.company.updateCompanyCapacityInfo({
updates: JSON.stringify(obj),
}).then((res) => {
const code = res.data;
if (code.code === 0 && code.sub_code === 0) {
if (this.companyStatus !== 0) {
this.$vux.confirm.show({
showCancelButton: false,
confirmText: '我知道了',
content: `<i class="iconfont icon-chenggong"></i>
<p class="save_ok">保存成功</p>`,
onConfirm () {
}
});
} else {
this.$router.push({
name: 'authCompanyApt',
});
}
}
});
}
},
},
};
